"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var MerryGoRound_1 = __importDefault(require("../MerryGoRound"));

var Certificate_1 = __importDefault(require("./Certificate"));

var constants_2 = __importDefault(require("./constants"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * Moment to display achievements.
 */


var AwardMoment = function AwardMoment(props) {
  var backgroundImage = props.backgroundImage,
      data = props.data,
      name = props.name,
      story = props.story;
  var classes = (0, useStyles_1.default)();

  var key = function key(_a, index) {
    var label = _a.label;
    return label + "-" + index;
  };

  var renderCertificates = function renderCertificates() {
    return data.map(function (award, index) {
      return react_1.default.createElement(Certificate_1.default, {
        color: award.color,
        conferred_by: award.conferred_by,
        description: award.description,
        icon: award.icon,
        key: key(award, index),
        label: award.label,
        name: award.name || name || story.label,
        style: award.style,
        subtitle: award.subtitle,
        year: award.year
      });
    });
  };

  var renderSideBarContent = function renderSideBarContent(award) {
    if (!award) return undefined;
    var _a = award.props,
        color = _a.color,
        // eslint-disable-next-line @typescript-eslint/naming-convention
    conferred_by = _a.conferred_by,
        image = _a.image,
        label = _a.label,
        website = _a.website;
    return react_1.default.createElement(Grid_1.default, {
      container: true,
      justifyContent: "center",
      spacing: 5
    }, react_1.default.createElement(Grid_1.default, {
      className: classes.sideBarBody,
      item: true,
      xs: 12
    }, react_1.default.createElement(Grid_1.default, {
      container: true,
      justifyContent: "center",
      spacing: 5
    }, react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 12
    }, react_1.default.createElement(Typography_1.default, {
      className: classes.sideBarHeader,
      variant: "h4"
    }, label), react_1.default.createElement(Divider_1.default, {
      variant: "middle"
    }), react_1.default.createElement("div", {
      className: classes.sideBarAward
    }, award), react_1.default.createElement(Divider_1.default, {
      variant: "middle"
    })), image && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement("img", {
      className: classes.sideBarImage,
      src: image,
      alt: label
    })), website && react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 10
    }, react_1.default.createElement(Button_1.default, {
      href: website,
      style: {
        background: color.light
      },
      target: "_blank",
      variant: "contained"
    }, "Learn More")))), conferred_by && react_1.default.createElement(Grid_1.default, {
      className: classes.sideBarFooter,
      item: true
    }, react_1.default.createElement(Typography_1.default, {
      variant: "h6"
    }, "This Award is Presented by", ' ', conferred_by.label), react_1.default.createElement(Divider_1.default, {
      className: classes.divider
    }), react_1.default.createElement(Typography_1.default, {
      variant: "overline"
    }, conferred_by.description)));
  };

  var style = {
    backgroundImage: "url(" + backgroundImage + ")",
    backgroundPositionY: '57%',
    backgroundSize: 'cover',
    minHeight: '80vh',
    width: '100%'
  };
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(MerryGoRound_1.default, __assign({}, props, {
    sideBarClassName: classes.sideBarRoot,
    sideBarContent: renderSideBarContent,
    style: style
  }), renderCertificates());
};

AwardMoment.propTypes = {
  backgroundImage: prop_types_1.default.string,

  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Information to build the `AwardCertificate`s */
  // eslint-disable-next-line react/forbid-prop-types
  data: prop_types_1.default.array.isRequired,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Determines the name written on the `AwardCertificate`s. */
  name: prop_types_1.default.string,

  /** `Story` Data */
  // eslint-disable-next-line react/forbid-prop-types
  story: prop_types_1.default.object,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
AwardMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  backgroundImage: constants_2.default,
  type: constants_1.MomentType.Award
});
exports.default = AwardMoment;